import React from "react";

const Extar = () => {
  // ✅ Exact Excel Static Data (All 5 Rows)
  const excelData = [
    {
      date: "05/02/2026",
      pidCampaignName: "mobidrago1a_int",
      pid: "mobidrago1a_int",
      event: "af_subscribe",
      totalCount: 8,
    },
    {
      date: "06/02/2026",
      pidCampaignName: "mobidrago1a_int",
      pid: "mobidrago1a_int",
      event: "af_subscribe",
      totalCount: 4,
    },
    {
      date: "07/02/2026",
      pidCampaignName: "mobidrago1a_int",
      pid: "mobidrago1a_int",
      event: "af_subscribe",
      totalCount: 3,
    },
    {
      date: "08/02/2026",
      pidCampaignName: "mobidrago1a_int",
      pid: "mobidrago1a_int",
      event: "af_subscribe",
      totalCount: 4,
    },
    {
      date: "09/02/2026",
      pidCampaignName: "mobidrago1a_int",
      pid: "mobidrago1a_int",
      event: "af_subscribe",
      totalCount: 5,
    },
  ];

  return (
    <div className="w-full md:ml-[4.4rem] px-4 md:px-8 lg:px-10 mt-20 bg-main-bg min-h-screen pb-12">
      <table className="w-full">
        <thead>
          <tr className="bg-main-th border-b-2 border-main-border">
            <th className="p-5 text-left text-main-font font-bold text-sm uppercase">
              Date
            </th>
            <th className="p-5 text-left text-main-font font-bold text-sm uppercase">
              PID Campaign Name
            </th>
            <th className="p-5 text-left text-main-font font-bold text-sm uppercase">
              PID
            </th>
            <th className="p-5 text-center text-main-font font-bold text-sm uppercase">
              Event
            </th>
            <th className="p-5 text-center text-main-font font-bold text-sm uppercase">
              Total Count
            </th>
          </tr>
        </thead>

        <tbody>
          {excelData.map((row, index) => (
            <tr
              key={index}
              className="border-b border-main-border/50 hover:bg-main-thHover transition-all duration-200"
            >
              <td className="p-5 text-main-font font-medium">
                {row.date}
              </td>

              <td className="p-5 text-main-font font-semibold">
                {row.pidCampaignName}
              </td>

              <td className="p-5 text-main-font">
                {row.pid || "-"}
              </td>

              <td className="p-5 text-center">
                <span className="px-4 py-2 bg-main-blue/10 text-main-blue font-semibold text-sm rounded-xl">
                  {row.event}
                </span>
              </td>

              <td className="p-5 text-center">
                <span className="px-4 py-2 bg-main-blue text-main-white font-bold text-base rounded-xl shadow-md">
                  {row.totalCount}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Extar;
